import {
    Grid,
    Box,
    Typography
} from "@mui/material";
  import ImageSlideshow from "../../components/ImageSlideShow";
  import musculoskeletal_dept_img1 from "../../assets/images/facilities/infrastructure/departments/musculoskeletal_Dept/musculoskeletal_img_1.jpg";
  import musculoskeletal_dept_img2 from "../../assets/images/facilities/infrastructure/departments/musculoskeletal_Dept/musculoskeletal_img_2.jpg";
  import musculoskeletal_dept_img3 from "../../assets/images/facilities/infrastructure/departments/musculoskeletal_Dept/musculoskeletal_img_3.jpg";
  import musculoskeletal_dept_img4 from "../../assets/images/facilities/infrastructure/departments/musculoskeletal_Dept/musculoskeletal_img_4.jpg";
  import musculoskeletal_dept_img5 from "../../assets/images/facilities/infrastructure/departments/musculoskeletal_Dept/musculoskeletal_img_5.jpg";
  import { ZoomInRounded } from "@mui/icons-material";
  import TransitionsModal from "../../components/modal/modal";
  import ImageSlider from "../../components/ImageSlider";
  import { useState } from "react";
import ContentLayout from "../../components/ContentLayout";
  
  type ImageType = {
    src: string;
    alt: string;
  };
  
  type DepartmentObject = {
    name: string;
    img: Array<ImageType>;
  };
  
  const DepartmentData: Array<DepartmentObject> = [
    {
      name: "Department of Musculoskeletal Physiotherapy",
      img: [
        { src: musculoskeletal_dept_img1, alt: "musculoskeletal_dept_img1" },
        { src: musculoskeletal_dept_img2, alt: "musculoskeletal_dept_img2" },
        { src: musculoskeletal_dept_img3, alt: "musculoskeletal_dept_img3" },
        { src: musculoskeletal_dept_img4, alt: "musculoskeletal_dept_img4" },
        { src: musculoskeletal_dept_img5, alt: "musculoskeletal_dept_img5" },
      ],
    }
  ];
  
  const MusculoskeletalPhysiotherapy = () => {
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState("");
    const [sliderImages, setSliderImages] = useState<Array<ImageType>>();

    return (
      <>
        <ContentLayout>
          <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Box sx={{ position: "relative" }} >
                  <ImageSlideshow
                    sx={{}}
                    images={DepartmentData[0]?.img as Array<ImageType>}
                    showCaption={false} showCount={false} />
                  <Box
                    sx={{
                      position: "absolute" as "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                    }}
                    onClick={() => {
                      setTitle(DepartmentData[0]?.name);
                      setSliderImages(DepartmentData[0]?.img);
                      setOpen(true);
                    } }
                  >
                    <ZoomInRounded
                      sx={{
                        color: "#fdd025",
                        zIndex: 99,
                        fontSize: "4rem",
                        "&:hover": {
                          fontSize: "6rem",
                        },
                      }} />
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography  variant="body2" textAlign="justify" mb={2} fontSize={"1rem"}>
                  Musculoskeletal Physiotherapy department at PES Modern College Of Physiotherapy is dedicated to training the next generation of experts in the assessment, treatment, and prevention of musculoskeletal conditions.
                  You will gain a deep understanding of the human body, focusing on the intricacies of bones, joints, muscles, and soft tissues.
                  Through a blend of theoretical knowledge and hands-on clinical experience, you will learn to diagnose, treat, and manage a wide range of musculoskeletal disorders, from sports injuries to chronic pain conditions.
                  Our program emphasizes evidence-based practice, patient-centered care, and the importance of promoting optimal movement and function.
                  Prepare to embark on a rewarding career where you can make a positive impact on the lives of individuals experiencing musculoskeletal pain and dysfunction.
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography  variant="body2" textAlign="justify" mb={2} fontSize={"1rem"}>
                  This course provides graduate physiotherapists with an opportunity to develop advanced clinical and practical skills in musculoskeletal physiotherapy, together with an opportunity to develop advanced clinical skills in sports physiotherapy, and aims to establish a standard of advanced clinical work and theory to meet the eligibility for graduates to apply for the title of Musculoskeletal Physiotherapist.
                </Typography>

                <Typography variant="body2" textAlign="justify" mb={2} fontSize={"1rem"} fontWeight={'bold'}>
                  Who is a Musculoskeletal Physiotherapist?
                </Typography>

                <Typography variant="body2" textAlign="justify" mb={2} fontSize={"1rem"}>
                  Musculoskeletal Physiotherapists have expertise in the treatment of musculoskeletal (muscle and joint) conditions.
                  Musculoskeletal Physiotherapy employs advanced clinical assessment and diagnosis method.
                  Musculoskeletal physiotherapists and have been trained in a broader range of treatment techniques and normally hold a Masters of Physiotherapy qualifications.
                </Typography>

                <Typography variant="body2" textAlign="justify" mb={2} fontSize={"1rem"} fontWeight={'bold'}>
                  How can Musculoskeletal Physiotherapy Help You?
                </Typography>

                <Typography component={'ul'} variant="body2" textAlign="justify" mb={2} fontSize={"1rem"} pl={2}>
                    <li>Relieve or reduce your pain.</li>
                    <li>Provide you with strategies to best manage your injury or condition.</li>
                    <li>Help you to recover quicker and hasten your return to your normal activities.</li>
                    <li>Improve your flexibility, muscle strength, quality of movement, proprioception and co-ordination.</li>
                    <li>Assist you to achieve exercise or functional goals.</li>
                    <li>Improve your fitness.</li>
                    <li>Help you to prevent future injury recurrences.</li>
                    <li>Prescribe exercises to do at home, work in the therapeutic gym to enhance your recovery.</li>
                </Typography>

              </Grid>
          </Grid>
        </ContentLayout>

        {sliderImages && (
          <TransitionsModal
            open={open}
            setOpen={setOpen}
            title={title}
            children={<Grid item xs={12} margin={"auto"}>
              <Box sx={{ width: "75%", margin: "auto" }}>
                <ImageSlider images={sliderImages} />
              </Box>
            </Grid>} />
        )}
      </>
    );
  };
  
  export default MusculoskeletalPhysiotherapy;
  